import React from 'react';
import './Icon.css';

export const Save = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 11.08V12C21.4988 14.1564 20.8005 16.2547 19.5093 17.9818C18.2182 19.709 16.4033 20.9725 14.3354 21.5839C12.2674 22.1953 10.0573 22.1219 8.03447 21.3746C6.01168 20.6273 4.28465 19.2461 3.11096 17.4371C1.93727 15.628 1.37979 13.4881 1.52168 11.3363C1.66356 9.18455 2.49721 7.13631 3.89828 5.49706C5.29935 3.85781 7.19279 2.71537 9.29619 2.24013C11.3996 1.7649 13.6003 1.98232 15.57 2.85999"
        stroke="#050505"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 4L11.5 14.01L8.5 11.01"
        stroke="#050505"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
